/**
 * **「이 키들은 빼고 보낸다」 한 곳** — 의존성 없는 순수 모듈이다(Vue·스토어·`@/` 별칭 금지).
 *
 * 이 앱의 저장은 폼 객체를 **통째로** 보낸다. 그래서 「보내지 않는다」는 결정이 곧 「폼에서 이 키를
 * 덜어낸다」가 되고, 같은 축약이 여러 곳에 생겼다 — 비밀번호 두 칸(`utils/accountPassword`)과 앱 회원의
 * 푸시 토큰(`views/AppUserListView`)이 각자 `Object.keys().filter().reduce()` 를 적고 있었다. 사본이
 * 둘이면 한쪽만 고쳐질 때(예: 상속 키·`undefined` 값의 처리) 화면마다 다른 본문이 나간다.
 *
 * 원본은 바꾸지 않고 **얕은 사본**을 돌려준다 — 남은 값은 같은 참조다(폼의 중첩 객체를 복제하지 않는다).
 */

/**
 * `source` 에서 `keys` 를 뺀 얕은 사본.
 *
 * `source` 가 없으면 빈 객체다(조회 실패·빈 응답을 폼에 담는 자리가 있다). 자기 자신의 열거 가능한
 * 키만 옮긴다 — 프로토타입에서 물려받은 것은 본문에 실을 값이 아니다.
 *
 * @param {?object} source 원본 (바뀌지 않는다)
 * @param {?Array<string>} keys 뺄 키
 * @returns {object}
 */
export function without(source, keys) {
  const origin = source || {}
  const omitted = Array.isArray(keys) ? keys : []

  return Object.keys(origin)
    .filter((key) => omitted.indexOf(key) === -1)
    .reduce((copy, key) => Object.assign(copy, { [key]: origin[key] }), {})
}
